import { InputNumber } from 'antd';
import styled from 'styled-components';

export const InputNumberStyled = styled(InputNumber)`
  width: 100%;
`;
